import type { ListStatus } from '../../types/lists';
import { useTranslation } from '../../i18n';

interface Props {
  status: ListStatus;
  label?: string;
  className?: string;
}

const TONE: Record<ListStatus, string> = {
  active: 'bg-emerald-500',
  inactive: 'bg-slate-300',
  'pending-plan': 'bg-amber-500',
};

const LABEL_KEY: Record<ListStatus, string> = {
  active: 'common:status.active',
  inactive: 'common:status.inactive',
  'pending-plan': 'common:status.pendingPlan',
};

export function StatusDotInline({ status, label, className = '' }: Props) {
  const { t } = useTranslation('common');
  const fallback = t(LABEL_KEY[status], {
    defaultValue: status === 'active' ? 'aktiv' : status === 'inactive' ? 'inaktiv' : 'ohne Plan',
  });
  return (
    <span
      className={`inline-flex items-center gap-1.5 text-[12px] text-slate-600 ${className}`}
    >
      <span className={`w-1.5 h-1.5 rounded-full ${TONE[status]}`} aria-hidden />
      {label ?? fallback}
    </span>
  );
}
